import { render, staticRenderFns } from "./EditorDialog.vue?vue&type=template&id=136080c1&"
import script from "./EditorDialog.vue?vue&type=script&lang=js&"
export * from "./EditorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136080c1')) {
      api.createRecord('136080c1', component.options)
    } else {
      api.reload('136080c1', component.options)
    }
    module.hot.accept("./EditorDialog.vue?vue&type=template&id=136080c1&", function () {
      api.rerender('136080c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/QuestionBank/components/EditQuestionInfoDialog/EditorDialog.vue"
export default component.exports